import React from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { Grid, Radio } from '@mui/material';
import { StyledLabel } from './styles';
import { EGalleryTypeAncillary, EGalleryTypeFirearm } from './helpers';
import { EModuleType } from '../ImagesGallery/helper';

interface IImagesGalleryRadioButton {
  moduleType: EModuleType;
  galleryType: string;
  setGalleryType: (arg: any) => void;
}

const ImagesGalleryRadioButton = ({
  galleryType,
  setGalleryType,
  moduleType,
}: IImagesGalleryRadioButton) => {
  const { t } = useTranslations();
  const EGalleryType =
    moduleType === EModuleType.ANCILLARY ? EGalleryTypeAncillary : EGalleryTypeFirearm;

  return (
    <Grid container sx={{ flexWrap: "nowrap", gap: "20px" }}>
      {moduleType === EModuleType.ANCILLARY && (
        <Grid sx={{ width: "auto", flexWrap: "nowrap" }}>
          <Radio
            checked={galleryType === EGalleryTypeAncillary.ART}
            onChange={() => setGalleryType(EGalleryTypeAncillary.ART)}
            sx={{ py: 0, pl: 0, pr: '0', mr: '8px' }}
          />
          <StyledLabel id={EGalleryTypeAncillary.ART}>
            {t('manageImages.art.label')}
          </StyledLabel>
        </Grid>
      )}
      {moduleType === EModuleType.FIREARM && (
        <Grid sx={{ width: "auto", flexWrap: "nowrap" }}>
          <Radio
            checked={galleryType === EGalleryTypeFirearm.FRT}
            onChange={() => setGalleryType(EGalleryTypeFirearm.FRT)}
            sx={{ py: 0, pl: 0, pr: '0', mr: '8px' }}
          />
          <StyledLabel id={EGalleryTypeFirearm.FRT}>{t('manageImages.frt.label')}</StyledLabel>
        </Grid>
      )}
      <Grid sx={{ width: "auto", flexWrap: "nowrap" }}>
        <Radio
          checked={galleryType === EGalleryType.Owner}
          onChange={() => setGalleryType(EGalleryType.Owner)}
          sx={{ py: 0, pl: 0, pr: '0', mr: '8px' }}
        />
        <StyledLabel id={EGalleryType.Owner}>
          {t('manageImages.specificItem.label')}
        </StyledLabel>
      </Grid>
    </Grid>
  );
};

export default ImagesGalleryRadioButton;
